// extracted by mini-css-extract-plugin
export default {"container":"styles__container___sgrJ7","initials":"styles__initials___FVG9z","photoIcon":"styles__photoIcon___zwoUr"};